import { memo } from 'react';

import { type Board } from '@air/api/types';
import { SlackIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { useToasts } from '@air/provider-toast';

// eslint-disable-next-line no-restricted-imports -- PLA-1724 — pre-existing debt, not introduced by the icon migration
import { useConnectToSlack } from '../hooks/useConnectToSlack';

type ConnectToSlackProps = {
  board: Board;
};

export const ConnectToSlack = memo(({ board }: ConnectToSlackProps) => {
  const { connectToSlack } = useConnectToSlack();
  const { showToast } = useToasts();

  // biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration
  const onConnectToSlack = () => {
    try {
      // biome-ignore lint/nursery/noFloatingPromises: PLA-1724 — pre-existing debt, not introduced by the icon migration
      connectToSlack({ board, trackLocation: 'edit-board-details-modal' });
    } catch (_error) {
      showToast('There was an error with slack authentication. Please try again later', {
        timeBeforeAutoDismiss: null,
        type: 'assertive',
        withCloseButton: true,
      });
    }
  };

  return (
    <Button
      appearance="filled"
      color="gray"
      size="extra-large"
      className="mt-2 w-full justify-start font-normal"
      prefix={<SlackIcon size="sm" />}
      onClick={onConnectToSlack}
    >
      Connect to Slack
    </Button>
  );
});

ConnectToSlack.displayName = 'ConnectToSlack';
